import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import PixelSelect from 'AdsUI/components/events/form-submission/PixelSelect'; // @ts-expect-error importing from JS file

import InstallPixelModalContainer from 'AdsUI/containers/audiences/InstallPixelModalContainer'; // @ts-expect-error importing from JS file

import { OfflineEventTriggers } from 'AdsUI/lib/Constants';
import DataSharing from './DataSharing';
import FacebookCapiEventName from './FacebookCapiEventName';
import FacebookCapiLifecycleStages from './FacebookCapiLifecycleStages';
import FacebookCapiLifecycleStageOption from './FacebookCapiLifecycleStageOption';
import { getAvailableLifecycleStages } from 'AdsUI/lib/events';
export const FACEBOOK_CAPI_LIFECYCLE_STAGES = ['subscriber', 'lead', 'marketingqualifiedlead', 'salesqualifiedlead', 'opportunity', 'customer', 'evangelist'];

/**
 * Fields for creating Facebook CAPI events.
 */
const FacebookCapiOptionsPanel = ({
  eventToReplace,
  onEventOptionsChange,
  eventOptions,
  showErrors,
  selectedAdAccount,
  usedLifecycleStagesByAccount
}) => {
  const options = eventOptions.facebookCapiLSC || {};
  const [openInstallPixelModal, setOpenInstallPixelModal] = useState(false);
  const [availableLifecycleStages, setAvailableLifecycleStages] = useState(FACEBOOK_CAPI_LIFECYCLE_STAGES);
  const handleSelectLifecycleStage = useCallback((selectedLifecycleStage, isChecked) => {
    let updatedLifecycleStages = options.selectedLifecycleStages ? [...options.selectedLifecycleStages] : [];

    if (isChecked) {
      updatedLifecycleStages.push(selectedLifecycleStage);
    } else {
      updatedLifecycleStages = updatedLifecycleStages.filter(lifecycleStage => lifecycleStage !== selectedLifecycleStage);
    }

    onEventOptionsChange({
      facebookCapiLSC: {
        selectedLifecycleStages: updatedLifecycleStages,
        numSelectedLifecycleStages: updatedLifecycleStages.length
      }
    });
  }, [onEventOptionsChange, options.selectedLifecycleStages]);
  const handleFacebookBusinessExtensionAuth = useCallback(auth => {
    onEventOptionsChange({
      facebookBusinessExtensionAuth: auth
    });
  }, [onEventOptionsChange]);
  useEffect(() => {
    const updateAvailableLifecycleStages = () => {
      const allLifecycleStages = FACEBOOK_CAPI_LIFECYCLE_STAGES;
      const availableStages = getAvailableLifecycleStages(allLifecycleStages, usedLifecycleStagesByAccount, eventOptions.selectedAdAccount && eventOptions.selectedAdAccount.adAccount, eventToReplace);

      if (!eventToReplace) {
        // Remove the used lifecycle stages from the pre-selected list
        onEventOptionsChange({
          facebookCapiLSC: {
            selectedLifecycleStages: availableStages,
            numSelectedLifecycleStages: availableStages.length
          }
        });
      }

      setAvailableLifecycleStages(availableStages);
    };

    if (eventOptions.selectedAdAccount) {
      updateAvailableLifecycleStages();
    }
  }, [eventOptions.selectedAdAccount, eventToReplace, usedLifecycleStagesByAccount, onEventOptionsChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PixelSelect, {
      showErrors: showErrors,
      selectedPixel: eventOptions.selectedPixel,
      addPixel: () => setOpenInstallPixelModal(true),
      facebookBusinessExtensionAuth: eventOptions.facebookBusinessExtensionAuth,
      selectedAdAccount: selectedAdAccount,
      handleSelectPixel: pixel => onEventOptionsChange({
        currentEventTrigger: OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE,
        selectedPixel: pixel
      })
    }), openInstallPixelModal && /*#__PURE__*/_jsx(InstallPixelModalContainer, {
      preselectedAdAccount: selectedAdAccount,
      onClose: () => setOpenInstallPixelModal(false),
      isEventCreation: true,
      onAuth: handleFacebookBusinessExtensionAuth
    }), /*#__PURE__*/_jsx(FacebookCapiLifecycleStages, {
      lifecycleStageOptions: FACEBOOK_CAPI_LIFECYCLE_STAGES.map(lifecycleStage => /*#__PURE__*/_jsx(FacebookCapiLifecycleStageOption, {
        isChecked: !options.selectedLifecycleStages ? false : options.selectedLifecycleStages.includes(lifecycleStage),
        isEnabled: availableLifecycleStages.includes(lifecycleStage),
        lifecycleStage: lifecycleStage,
        handleSelectLifecycleStage: handleSelectLifecycleStage
      }, lifecycleStage)),
      numSelectedLifecycleStages: options.numSelectedLifecycleStages,
      showErrors: showErrors
    }), /*#__PURE__*/_jsx(DataSharing, {
      allowWithoutAdInteraction: eventOptions.allowEventStreamingForContactsWithoutAdInteraction,
      handleSelect: allowWithoutAdInteraction => onEventOptionsChange({
        allowEventStreamingForContactsWithoutAdInteraction: allowWithoutAdInteraction
      })
    }), /*#__PURE__*/_jsx(FacebookCapiEventName, {})]
  });
};

export default FacebookCapiOptionsPanel;